module.exports = __webpack_public_path__ + "img/type1.b1d91149.png";